import { render } from "./VCardList.vue?vue&type=template&id=63145446"
import script from "./VCardList.vue?vue&type=script&lang=js"
export * from "./VCardList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__